// extracted by mini-css-extract-plugin
module.exports = {"drawer":"FontsDrawer_drawer__38W9d"};